import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToSectionWhenReady } from '@/lib/scrollToSection';

export default function ScrollToHash() {
    const { pathname, hash } = useLocation();
    const previousPathname = useRef(pathname);

    useEffect(() => {
        if (!hash) {
            previousPathname.current = pathname;
            return undefined;
        }

        const id = decodeURIComponent(hash.slice(1));
        const navigatedToHome = previousPathname.current !== pathname && pathname === '/';
        previousPathname.current = pathname;

        return scrollToSectionWhenReady(id, {
            initialDelayMs: navigatedToHome ? 450 : 0,
            maxAttempts: 40,
            intervalMs: 50,
        });
    }, [pathname, hash]);

    return null;
}
